import routes from '@modules/category/category-routes';
import store from '@modules/category/category-store';

export default {
  routes,
  store,
};
